import list from '@/components/order/list/storage';
import edit from '@/components/order/edit/storage';

export default {
    namespaced: true,
    modules: {
        list,
        edit,
    },
    state: {
    },
    getters: {
    },
    mutations: {
    },
    actions: {
    }
}